var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuedate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ng-star-inserted",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "cu-stroke",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    strokeDasharray: 3,
    className: "cu-stroke-dasharray",
    stroke: "#979797",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 10.3,
    width: 17.1,
    height: 15.3,
    rx: 2,
    stroke: "#979797",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 20.2339051L16.5687413 22.05 21.6 17.55",
    stroke: "#979797",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.9 14.4H26.1V15.4H9.9zM12.6 8.1H13.6V12.6H12.6zM22.5 8.1H23.5V12.6H22.5z",
    className: "cu-fill",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuedate);
export default __webpack_public_path__ + "static/media/duedate.c11b2f753f03d49769b6ba9b2c05d7b7.svg";
export { ForwardRef as ReactComponent };